























































































































































import { UserRegistration } from "@/api/models/user-registration.ts";
import UsersApi, { courseApi } from "@/getinfo-api";
import { Component, Prop, Vue } from "vue-property-decorator";
import CustomInput from "@/components/form/CustomInput.vue";
import { AxiosError } from "axios";
import { ErrorResponse as IErrorResponse } from "@/api/models/error-response";
import { ValidationErrorResponse as IValidationErrorResponse } from "@/api/models/validation-error-response";
import { User as IUser } from "@/api/models/user";
import { getCurrentCompanyId, isRoot } from "@/plugins/roles";
import CustomButton from "@/components/form/CustomButton.vue";
import UserGenerator from "@/components/user/UserGenerator.vue";
import CField from "@/components/form/CField.vue";
import userList, { UsersListParams } from "@/getinfo-api/users";
import { UsersList as IUsersList } from "@/api/models";
import CustomDatepicker from "@/components/form/CustomDatepicker.vue";
import { UserDocumentInfoEdit as IUserDocumentInfoEdit } from "@/api/models/user-document-info-edit";
import Modal from "@/components/form/Modal.vue";

@Component({
  components: {
    Modal,
    CustomDatepicker,
    CField,
    UserGenerator,
    CustomButton,
    CustomInput
  }
})
export default class Registration extends Vue {
  @Prop() inModal?: boolean;
  private username: string = "";
  private email: string = "";
  private snils: string = "";
  private plainPassword: string = "";
  private firstName: string = "";
  private lastName: string = "";
  private phone: string = "";
  private middleName: string = "";
  private spinnerButton: boolean = false;
  isStudent: boolean = false;
  showPassword: boolean = false;
  passwordFieldType = "password";
  users!: IUser;
  existedUsers: IUser[] = [];
  modalShow = false;
  birthdayAtMin!: Date | undefined;

  data() {
    return {
      birthdayAtMin: undefined,
      birthdayAtMax: undefined,
      birthday: undefined
    };
  }

  togglePasswordView() {
    this.showPassword = !this.showPassword;
    if (this.passwordFieldType === "password") {
      this.passwordFieldType = "text";
    } else {
      this.passwordFieldType = "password";
    }
  }

  get isShowCopyPasswordIcon() {
    return (
      (this.username?.length || this.email?.length) &&
      this.plainPassword?.length
    );
  }

  get root() {
    return isRoot();
  }

  get company() {
    return getCurrentCompanyId();
  }

  copy() {
    const text = `Email: ${
      this.email ? this.email : `${this.$tc(this.$translate.NotFilled)}`
    }\n${this.$tc(this.$translate.Login)}: ${
      this.username ? this.username : `${this.$tc(this.$translate.NotFilled)}`
    }\n${this.$tc(this.$translate.Password)}: ${this.plainPassword}\n${
      window.location.origin
    }`;
    navigator.clipboard.writeText(text);
    this.$store.dispatch("successToast", {
      message: `${this.$tc(this.$translate.Success)}`
    });
  }

  getGeneratedUser(data: { mail: string; password: string }) {
    this.setEmail(data.mail);
    this.setUserName(data.mail);
    this.setPlainPassword(data.password);
  }

  setFirstName(item: string) {
    this.firstName = item;
    this.firstName[0].toUpperCase();
  }

  setLastName(item: string) {
    this.lastName = item;
  }

  setUserName(item: string) {
    this.username = item;
  }

  setMiddleName(item: string) {
    this.middleName = item;
  }

  setPhone(item: string) {
    this.phone = item;
  }

  setEmail(item: string) {
    this.email = item;
  }

  setPlainPassword(item: string) {
    this.plainPassword = item;
  }

  public registration() {
    this.modalShow = false;
    this.spinnerButton = true;

    const userInfo: UserRegistration = {
      username: this.username,
      email: this.email,
      plainPassword: this.plainPassword,
      firstName: this.firstName,
      lastName: this.lastName,
      middleName: this.middleName ? this.middleName : undefined,
      birthday: this.birthdayAtMin = this.birthdayAtMin
        ? this.birthdayAtMin
        : undefined,
      phone: this.phone ? this.phone : undefined
    };

    const userSnilsInfo: IUserDocumentInfoEdit = {
      snils: this.snils
    };

    UsersApi.UsersApi.registration(userInfo)
      .then((res: { data: IUser }) => {
        if (this.snils) {
          UsersApi.UsersApi.editDocumentInfo(res.data.id, userSnilsInfo);
        }

        if (this.isStudent) {
          courseApi.Student.createStudent({
            firstName: userInfo.firstName,
            lastName: userInfo.lastName,
            middleName: userInfo.middleName,
            birthday: this.birthdayAtMin ? this.birthdayAtMin : undefined,
            email: this.email,
            userId: res.data.id,
            companyId: this.company,
            phone: this.phone
          }).then(result => {
            if (this.inModal) {
              /**
               emit user потому что в текущих курсах используется информация о пользователя, а не о студенте
               */
              this.$emit("success", res.data);
            } else {
              let routeData = this.$router.resolve({
                name: "student",
                params: { id: result.data.id }
              });

              window.open(routeData.href, "_blank");
            }
          });
        } else if (this.inModal) {
          /**
           В случае если не выбрано, что к пользователю прикрепляется студент, выполняется старый сценарий
           */
          this.$emit("success", res.data);
        } else {
          let routeData = this.$router.resolve({
            name: "userProfileView",
            params: { id: res.data.id }
          });

          window.open(routeData.href, "_blank");
        }
      })
      .catch((error: AxiosError<IErrorResponse | IValidationErrorResponse>) => {
        if (error.response) {
          this.$store.dispatch("errorException", {
            vm: this,
            error: error.response
          });
        } else {
          this.$bvToast.toast(`${this.$tc(this.$translate.Error)}`, {
            variant: "danger",
            title: `${this.$tc(this.$translate.SorrySomethingWentWrong)}`
          });
        }
      })
      .finally(() => {
        this.spinnerButton = false;
      });
  }

  checkExistUser() {
    if (this.lastName.length && this.firstName.length) {
      const birthdayAtMin = this.birthdayAtMin
        ? new Date(this.birthdayAtMin)
        : undefined;
      birthdayAtMin?.setHours(0, 0, 0, 0);
      const birthdayAtMax = birthdayAtMin ? new Date(birthdayAtMin) : undefined;
      birthdayAtMax?.setHours(23, 59, 0, 0);

      let params: UsersListParams = {
        lastName: this.lastName,
        firstName: this.firstName,
        middleName: this.middleName ? this.middleName : undefined,
        birthdayMax: birthdayAtMax,
        birthdayMin: birthdayAtMin,
        snils: this.snils ? this.snils : undefined
      };

      userList(params).then((res: { data: IUsersList }) => {
        if (res.data.users?.length) {
          this.existedUsers = res.data.users;
          this.modalShow = true;
        } else {
          this.registration();
        }
      });
    } else {
      this.$bvToast.toast(
        `${this.$tc(this.$translate.RequiredData)}: ${this.$tc(
          this.$translate.FirstName
        )}, ${this.$tc(this.$translate.Surname)}`,
        {
          variant: "danger",
          title: `${this.$tc(this.$translate.Error)}`
        }
      );
    }
  }

  created() {
    if (!this.company) {
      if (!this.root) {
        this.$router.push({ name: "error" });
      }
    }
  }
}
